/* unplugin-vue-components disabled */import script from "./JudgeFilterBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./JudgeFilterBlock.vue?vue&type=script&setup=true&lang=ts"

import "./JudgeFilterBlock.vue?vue&type=style&index=0&id=c9182e12&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9182e12"]])

export default __exports__